export const ASSIGNMENT_TYPE = {
  VIDEO: 'VIDEO',
  ASSIGNMENT: 'ASSIGNMENT',
}
